import React from 'react';

import { IWizardStepProps, WizardContext } from '../../Wizard';
import { Container, Content, Actions, ContentText, Heading } from '../common';
import { Checkbox, CheckboxContainer } from '../common/Checkbox';
import { EVERYDAY_REWARDS, HOME_SUPPORT, NO_REWARDS } from '../constants';
import { HomeSupportIcon, EverydayRewardsIcon, NoRewardIcon } from '../icons';

export class RewardType extends React.Component<IWizardStepProps> {
  static contextType = WizardContext;

  handleRewardsPreference = (event) => {
    this.context.saveAnswers({
      rewardType: event.target.value,
    });
  };

  render() {
    const { rewardType, electricity } = this.context.answers;
    return (
      <Container>
        <Content>
          <Heading>Interested in great value add-ons?</Heading>
          <ContentText>
            You can choose to earn Everyday Rewards points based on
            your energy usage and applicable to Woolworths, Big W, BWS and Caltex Woolworths – OR
            – get a 12-month emergency home assistance membership, supported by Allianz Global
            Assist. Whether you’re a homeowner, landlord, renter or single-person households, you
            can get 24/7 support for when home emergencies strike.
          </ContentText>

          <CheckboxContainer>
            <Checkbox
              label="I’d like to earn Everyday Rewards points"
              name="rewardType"
              type="radio"
              value={EVERYDAY_REWARDS}
              checked={rewardType === EVERYDAY_REWARDS}
              onChange={this.handleRewardsPreference}
            >
              <EverydayRewardsIcon />
            </Checkbox>
            <Checkbox
              label="I’m interested in Allianz Emergency Home Support"
              name="rewardType"
              type="radio"
              value={HOME_SUPPORT}
              checked={rewardType === HOME_SUPPORT}
              onChange={this.handleRewardsPreference}
              disabled={!electricity}
            >
              <HomeSupportIcon />
            </Checkbox>
            <Checkbox
              label="No add-ons, just a straight-up energy plan!"
              name="rewardType"
              type="radio"
              value={NO_REWARDS}
              checked={rewardType === NO_REWARDS}
              onChange={this.handleRewardsPreference}
            >
              <NoRewardIcon />
            </Checkbox>
          </CheckboxContainer>
          <Actions {...this.props} />
        </Content>
      </Container>
    );
  }
}
